import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import { salesAPI, usersAPI } from "../../api/api";

const sourceLabel = (source) => {
    switch (source) {
        case 'check_status': return 'Frontend yoxlama';
        case 'admin_refresh': return 'Admin tək yoxlama';
        case 'admin_bulk': return 'Admin toplu yoxlama';
        case 'backfill': return 'İlkin tarixçə';
        case 'manual': return 'Əl ilə';
        default: return source || '—';
    }
};

const statusText = (value) => {
    switch (value) {
        case 0: return 'Gözləmədə';
        case 1: return 'Uğurlu';
        case 2: return 'Uğursuz';
        default: return '—';
    }
};

const formatDate = (value) => {
    if (!value) return '—';
    const d = new Date(value);
    return isNaN(d.getTime()) ? value : d.toLocaleString('az-AZ');
};

const HistoryModal = ({ show, onHide, saleId }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const users = useSelector(state => state.usersPage?.users || []);
    const [fetchedUsers, setFetchedUsers] = useState({});
    const pendingRef = useRef({});

    const userName = (userId, source) => {
        if (userId === null || userId === undefined) {
            switch (source) {
                case 'check_status': return 'Sistem (avtomatik, saytdan)';
                case 'backfill': return 'Sistem (ilkin qeyd)';
                default: return 'Sistem';
            }
        }
        const found = users.find(u => u.id === userId);
        if (found) return found.name;
        if (fetchedUsers[userId]) return fetchedUsers[userId];
        return `#${userId}`;
    };

    // Tarixçədəki user_id-ləri redux-da yoxdursa, API-dən çək
    useEffect(() => {
        if (!data || !data.history) return;
        const ids = Array.from(new Set(
            data.history
                .map(h => h.user_id)
                .filter(id => id !== null && id !== undefined)
        ));
        ids.forEach(id => {
            if (users.find(u => u.id === id)) return;
            if (fetchedUsers[id]) return;
            if (pendingRef.current[id]) return;
            pendingRef.current[id] = true;
            usersAPI.getUserById(id).then(res => {
                // Backend cavabı: { user: { id, name, email, role, ... } }
                const u = res?.user || res?.data?.user || res?.data || res;
                const name = u?.name || u?.full_name || u?.username || u?.email;
                if (name) {
                    setFetchedUsers(prev => ({ ...prev, [id]: name }));
                } else {
                    console.warn('getUserById: ad tapılmadı', id, res);
                }
            }).finally(() => {
                delete pendingRef.current[id];
            });
        });
    }, [data, users]);

    useEffect(() => {
        if (!show || !saleId) return;
        let cancelled = false;
        setLoading(true);
        setData(null);
        salesAPI.getSaleHistory(saleId).then(res => {
            if (!cancelled) setData(res);
        }).finally(() => {
            if (!cancelled) setLoading(false);
        });
        return () => { cancelled = true; };
    }, [show, saleId]);

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Satış tarixçəsi #{saleId}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading && <div className="text-center">Yüklənir...</div>}
                {!loading && data && (
                    <>
                        <div className="mb-3">
                            <strong>Cari status:</strong> {statusText(data.current_paymentStatus)}
                            {data.current_status_description && <> ({data.current_status_description})</>}
                            <br />
                            <strong>Ödəniş tarixi:</strong> {formatDate(data.paid_at)}
                        </div>
                        <div style={{ overflowX: 'auto' }}>
                            <table className="table table-sm table-bordered" style={{ whiteSpace: 'nowrap' }}>
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Tarix</th>
                                    <th>Köhnə</th>
                                    <th>Yeni</th>
                                    <th>Mənbə</th>
                                    <th>İstifadəçi</th>
                                </tr>
                                </thead>
                                <tbody>
                                {data.history && data.history.length > 0 ? data.history.map(h => (
                                    <tr key={h.id}>
                                        <td>{h.id}</td>
                                        <td>{formatDate(h.created_at)}</td>
                                        <td>{statusText(h.old_payment_status)}</td>
                                        <td>{statusText(h.new_payment_status)}</td>
                                        <td>{sourceLabel(h.source)}</td>
                                        <td>{userName(h.user_id, h.source)}</td>
                                    </tr>
                                )) : (
                                    <tr><td colSpan="6" className="text-center">Tarixçə yoxdur</td></tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                {!loading && !data && <div className="text-center text-muted">Məlumat yoxdur</div>}
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-secondary" onClick={onHide}>Bağla</button>
            </Modal.Footer>
        </Modal>
    );
};

export default HistoryModal;
